export default __webpack_public_path__ + "static/try-bg-669d148d7078a74396a2d79a3e71700d.png";